import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon } from '../../Svg/Index.js'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { GET_USERS } from '../../Actions/User'
import { CHECK_EXISTING_OR_NEW } from '../../Actions/Chat'
import { withRouter } from 'react-router-dom';

const debounce = (fn, time) => {
    let timeout;
    return function() {
      const functionCall = () => fn.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
}
class NewChat extends Component {

    state = {
        searchQuery: '',
    }

    componentDidMount() {
        this.props.actions.GET_USERS()
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
    }

    showProfile = (e, userId) => {
        if(e.target.classList.contains('c-btn')) return;
        this.props.actions.SET_PROFILE_OPEN(userId);
    }

    handleChat = (user) => {
        this.props.actions.CHECK_EXISTING_OR_NEW(user._id).then(thread => {
            if(thread._uuid) {
                //Thread found
                this.props.history.push('/messages')

                this.props.history.push({
                    pathname: `/chat`,
                    threadId: thread._uuid,
                    user: user
                })

            } else {
                //Thread not found
                this.props.history.push('/messages')

                this.props.history.push({
                    pathname: `/chat`,
                    newChat: true,
                    user: user
                })
                
            }
        })
    }

    handleSearch = (q)=> {
        if(this.refs.filter.value.length > 1) {
            this.props.actions.GET_USERS(this.refs.filter.value)
        } else if(this.refs.filter.value.length === 0) {
            this.props.actions.GET_USERS()
        }
    }
    render() {
        const { searchQuery } = this.state;


        let sentRequests = this.props.user.sent_friend_requests.map(r => {
            return r.friend;
        });

        let filteredUsers = this.props.users.filter(r => {
            if(searchQuery.length) {
                return r.display_name.toLowerCase().includes(searchQuery.toLowerCase())
            } else {
                return true
            }
        })

        let allUsers = [...sentRequests, ...filteredUsers];
       
        return (
            <div className="c-sidebar-overlay">
                <div className="c-sidebar-overlay__inner">
                    <button className="c-btn c-btn--back" onClick={ () => this.changeType('') }>
                        <BackIcon />
                    </button>

                    <h2 className="c-sidebar-overlay__title">Met wie wil je chatten?</h2>

                    <input className="o-search" placeholder="Zoek op naam of woonplaats..." type="text" ref="filter" 
                        onChange={debounce(text => {
                            this.handleSearch(text)
                        }, 500)} 
                    />

                    <ul className="c-list">
                        {
                            allUsers.map((item, i) => 
                                item && (
                                    <li className="c-list__item" onClick={(e) => this.showProfile(e, item._id)} key={`user-${item._id}}`}>
                                        <div className="c-list-user">
                                            <div className="c-list-avatar" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                            </div>
                                            <span className="c-list-user__name">{item.display_name}</span>
                                            <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={ () => this.handleChat(item) }>Stuur bericht</button>
                                        </div>
                                    </li>
                                )
                            )
                        }
                        
                    </ul>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        users: state.users.list,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TYPE, SET_PROFILE_OPEN, GET_USERS, CHECK_EXISTING_OR_NEW}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewChat))